/**
 * Configuration error classes.
 */

/** Base configuration error. */
export class ConfigError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ConfigError';
  }
}

/**
 * Thrown when runtime configuration fails validation.
 * Carries the full list of offending keys/reasons for display on ConfigErrorPage.
 */
export class ConfigValidationError extends ConfigError {
  public readonly errors: string[];

  constructor(errors: string[]) {
    const message = `Configuration validation failed:\n${errors.map((e) => `  • ${e}`).join('\n')}`;
    super(message);
    this.name = 'ConfigValidationError';
    this.errors = errors;
  }
}
